import { render } from "./FullNameInput.vue?vue&type=template&id=428506ce&scoped=true"
import script from "./FullNameInput.vue?vue&type=script&lang=js"
export * from "./FullNameInput.vue?vue&type=script&lang=js"

import "./FullNameInput.vue?vue&type=style&index=0&id=428506ce&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-428506ce"]])

export default __exports__